var file_upload_viewer_default = {
  "fontElementMap": "xdgwi",
  "file_upload_container": "eNLgt",
  "file_upload_error_container": "aPSuN",
  "file_upload_link": "VjNnq",
  "width_three": "_2pXvA",
  "file_upload_text_container": "QAuuE",
  "width_two": "IyzMd",
  "file_upload_state": "_9k71s",
  "mobile_status_icon": "RBdc1",
  "file_upload_name_container": "_7P9n5",
  "file_upload_name": "qoorc",
  "file_upload_extension": "_6waIO",
  "width_one": "_71xsn",
  "file_upload_type_icon": "_7QuqP",
  "file_loader_icon": "XfzWF",
  "spin": "FDa1i",
  "file_upload_type": "UFcA4",
  "file_upload_text_error": "-QCuH",
  "file_upload_icon_frame": "MY41w",
  "file_upload_icon_background": "VGeVg"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
